// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_content__FoH6U {
  padding: 0 1.5rem 2rem; }

.styles_card__1o8Hj,
.styles_subscriptionCard__91xNz {
  width: 100%;
  max-width: 46rem;
  margin: 0 auto;
  padding: 1rem 1.25rem 1.5rem; }

.styles_subscriptionCard__91xNz {
  padding-bottom: 0.75rem; }

.styles_account__B14vV {
  gap: 1.5rem;
  padding: 0.5rem 0.25rem 0; }

.styles_passwordBlock__lyKc1 {
  gap: 0.75rem;
  padding-top: 0.5rem; }

.styles_passwordTitle__G1fQ\\+ {
  font-weight: 700;
  color: #808080e6; }

.styles_passwordCopy__z8zBN {
  color: #808080b8;
  line-height: 1.5;
  max-width: 36rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/auth/components/screens/AccountSettings/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,sBAAsB,EAAA;;AAG1B;;EAEI,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,4BAA4B,EAAA;;AAGhC;EACI,uBAAuB,EAAA;;AAG3B;EACI,WAAW;EACX,yBAAyB,EAAA;;AAG7B;EACI,YAAY;EACZ,mBAAmB,EAAA;;AAGvB;EACI,gBAAgB;EAChB,gBCZc,EAAA;;ADelB;EACI,gBCjBc;EDkBd,gBAAgB;EAChB,gBAAgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.content {\n    padding: 0 1.5rem 2rem;\n}\n\n.card,\n.subscriptionCard {\n    width: 100%;\n    max-width: 46rem;\n    margin: 0 auto;\n    padding: 1rem 1.25rem 1.5rem;\n}\n\n.subscriptionCard {\n    padding-bottom: 0.75rem;\n}\n\n.account {\n    gap: 1.5rem;\n    padding: 0.5rem 0.25rem 0;\n}\n\n.passwordBlock {\n    gap: 0.75rem;\n    padding-top: 0.5rem;\n}\n\n.passwordTitle {\n    font-weight: 700;\n    color: $grey90;\n}\n\n.passwordCopy {\n    color: $grey72;\n    line-height: 1.5;\n    max-width: 36rem;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `styles_content__FoH6U`,
	"card": `styles_card__1o8Hj`,
	"subscriptionCard": `styles_subscriptionCard__91xNz`,
	"account": `styles_account__B14vV`,
	"passwordBlock": `styles_passwordBlock__lyKc1`,
	"passwordTitle": `styles_passwordTitle__G1fQ+`,
	"passwordCopy": `styles_passwordCopy__z8zBN`
};
export default ___CSS_LOADER_EXPORT___;
